<template>
  <!-- Footer -->
  <footer class="my-5 mx-auto d-flex footer">

    <!-- Details -->
    <div class="d-none d-sm-block col me-4">
      <h1>Market Hall Cafe</h1>
      <small>We are a well established, widely known and loved cafe and takeaway in the heart of Wellington Market.
      </small>
    
    </div>

    <!-- Site Map -->
    <div class="ms-4 ms-sm-0 me-4 sitemap col d-flex flex-column">
      <h3 class="mb-3">SITEMAP</h3>
      <router-link to="">Home</router-link>
      <router-link to="/our-food">Our Food</router-link>
      <router-link to="/contact">Contact</router-link>
      <router-link to="/legal">Legal</router-link>

    </div>
    <!-- Social Media -->
    <!-- <div class="social-media-container me-4 me-sm-0 col-auto d-flex">

      <a href="https://www.facebook.com/dolphinfishbar81" class="btn-icon me-3">
        <img alt="facebook" src="../assets/img/facebook.webp">
      </a>
    </div> -->

  </footer>
</template>

<script>
export default {
  name: 'RuggedSeparator',
  props: {
    isTop: {
      type: Boolean,
      default: true
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  max-width: 800px;
  width: 100%;
}

.sitemap a {
  height: 30px;
}

@media (max-width:800px) {



  .social-media-container {
    flex-direction: column;
  }

  .social-media-container * {
    margin-bottom: 10px;
  }



}
</style>
